__webpack_require__.p = "https://cdn-kaspi.kz/kkz/onlineproducts/bundles/mybank/goldkids/";